import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
import { initInvestmentCalculatorPage } from "./lib/investment_calculator"
import { initContributionPlannerPage } from "./lib/contribution_planner"
import { initTfsaCalculatorPage } from "./lib/tfsa_calculator"
import { initXeqtPriceTicker } from "./lib/xeqt_price"
import { initComparisonTool } from "./lib/comparison"


document.addEventListener("DOMContentLoaded", () => {
  initInvestmentCalculatorPage()
  initContributionPlannerPage()
  initTfsaCalculatorPage()
  initXeqtPriceTicker()
  initComparisonTool()

  // Sticky mobile CTA: slides in after scrolling past the hero, hides for
  // the rest of the session once dismissed. Body padding keeps it from
  // covering footer content.
  var stickyCta = document.getElementById("stickyCta");
  // sessionStorage throws in sandboxed iframes / aggressive privacy modes,
  // which would abort the rest of this handler (table wrapping). Guard it so
  // the handler survives; fallback is the CTA simply behaves as non-dismissed.
  var stickyCtaDismissed = false;
  try { stickyCtaDismissed = !!sessionStorage.getItem("stickyCtaDismissed"); } catch (e) { /* storage unavailable — CTA just shows again */ }
  if (stickyCta && !stickyCtaDismissed) {
    var updateStickyCta = function () {
      var show = window.scrollY > 500;
      stickyCta.classList.toggle("sticky-cta--visible", show);
      document.body.style.paddingBottom = show ? stickyCta.offsetHeight + "px" : "";
    };
    stickyCta.querySelector(".sticky-cta__close").addEventListener("click", function () {
      try { sessionStorage.setItem("stickyCtaDismissed", "1"); } catch (e) { /* storage unavailable — nothing to persist */ }
      stickyCta.classList.remove("sticky-cta--visible");
      document.body.style.paddingBottom = "";
    });
    window.addEventListener("scroll", updateStickyCta, { passive: true });
    updateStickyCta();
  }

  // Wrap tables in a scrollable container for mobile
  // The comparison tool brings its own scroll container, so skip those.
  document.querySelectorAll("main table:not(.cmp-table)").forEach((table) => {
    if (!table.parentElement.classList.contains("table-wrap")) {
      const wrapper = document.createElement("div")
      wrapper.className = "table-wrap"
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    }
  })
})
